<p-table [value]="policyDocuments"
         [lazy]="true"
         [loading]="!policyDocuments"
         (onLazyLoad)="onPageChange($event)"
         class="admin-table">

  <ng-template pTemplate="emptymessage" let-columns>
    <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
  </ng-template>

  <ng-template pTemplate="caption">
    <div class="ui-g">
      <div class="ui-g-3">
        <input pInputText
               [(ngModel)]="filter.name"
               (keyup)="search()"
               [placeholder]=" 'WS_DIRECTORY.SEARCH.PLACEHOLDER' | translate">
      </div>
      <div class="ui-g-9">
        <button pButton class="ui-button-success fright"
                label="{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.ADD' | translate }}"
                (click)="create()"></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 60%">{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.TITLE' | translate }}</th>
      <th>{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.ORDER' | translate }}</th>
      <th>{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.INACTIVE' | translate }}</th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template let-orgPolicyDocument pTemplate="body">
    <tr>
      <td>
        {{orgPolicyDocument.documentName}}
      </td>
      <td>
        {{orgPolicyDocument.documentOrder}}
      </td>
      <td>
        <span>{{ orgPolicyDocument.inactive ? 'Inactive' : '' }}</span>
      </td>
      <td class="action-column">
        <i class="fa fa-pen edit-appointment fright"
           (click)="modify(orgPolicyDocument)"
           pTooltip="{{ 'WS_DIRECTORY.ORGANIZATION_TYPE.MODIFY_TOOLTIP' | translate }}"></i>
      </td>
    </tr>
  </ng-template>
</p-table>

<wsd-add-policy-documents (onSave)="onSave($event)"
                          [policyDocumentsCount]="policyDocuments?.length"></wsd-add-policy-documents>

<wsd-global-messages [life]="4000"></wsd-global-messages>
